<template>
    <div class="hero-banner-content xl:pt-spc6 lg:pt-spc6 pt-spc6 md:pt-spc61 xl:pb-spc8 lg:pb-spc8 pb-spc8 md:pb-spc45">
        <div class="hero-banner-content-inner max-w-820px">
            <h1 v-if="title" class="xl:text-size1 lg:text-size1 text-size1 md:size7 text-white font-medium leading-spc2 mb-spc5 whitespace-pre-line">
                {{title}}
                <VueTyper
                    :text='["Alcohol Delivery","Cannabis Delivery","Grocery Delivery","Flower Delivery","Mobile Mechanic","Pharmacy Delivery","Courier", "Restaurant","Auto Parts Delivery","Landscaping","Snow Plowing","Driveway Sealing","Maintenance"]'
                    :repeat='Infinity'
                    :shuffle='false'
                    initial-action='typing'
                    :pre-type-delay='70'
                    :type-delay='70'
                    :pre-erase-delay='2000'
                    :erase-delay='150'
                    erase-style='backspace'
                    :erase-on-complete='false'
                    caret-animation='blink'
            ></VueTyper>
            </h1>
            <p v-if="desc" class="whitespace-pre-line text-white opacity-75 leading-6 mb-spc7">
                {{desc}}
            </p>
            <div class="hero-banner-content-btns flex items-start">
                <ThemeButton :title="btn1title" :url="btn1url" className="theme-border-btn opacity-90 mr-spc3 border-solid" />
                <ThemeButton :title="btn2title" :url="btn2url" />
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeButton from "../../common/ThemeButton";
    import { VueTyper } from 'vue-typer'

    export default {
        name: "HeroBanner",
        props: ['title', 'desc', 'btn1title', 'btn1url', 'btn2title', 'btn2url', ],
        components: {
            ThemeButton,
            VueTyper
        },
    }
</script>

<style scoped>

</style>